const ENVIRONMENTS = {
  production: {
    BASE_URL: "https://atp.acrossassist.in",
    ATP_API_BASE_URL: "https://atpapi.acrossassist.in/api/",
    DEFAULT_CLIENT: {
      CLIENT_ID: 11,
      CLIENT_NAME: "EMT",
    },
    VOUCHER_DEFAULT_VALUES: {
      CLAIM_INTIMATION: 48, // in hours
      MAXIMUM_VOUCHER_VALUE: 8000, // in INR
      VOUCHER_VALIDITY: 10, // in Days
    },
  },
  staging: {
    BASE_URL: "https://atpuat.acrossassist.in",
    ATP_API_BASE_URL: "https://atpuatapi.acrossassist.in/api/",
    DEFAULT_CLIENT: {
      CLIENT_ID: 11,
      CLIENT_NAME: "EMT",
    },
    VOUCHER_DEFAULT_VALUES: {
      CLAIM_INTIMATION: 48, // in hours
      MAXIMUM_VOUCHER_VALUE: 8000, // in INR
      VOUCHER_VALIDITY: 10, // in Days
    },
  },
  development: {
    BASE_URL: "http://localhost:3000",
    ATP_API_BASE_URL: "https://atpuatapi.acrossassist.in/api/",
    DEFAULT_CLIENT: {
      CLIENT_ID: 11,
      CLIENT_NAME: "EMT",
    },
    VOUCHER_DEFAULT_VALUES: {
      CLAIM_INTIMATION: 48, // in hours
      MAXIMUM_VOUCHER_VALUE: 8000, // in INR
      VOUCHER_VALIDITY: 10, // in Days
    },
  },
};

const getEnvironment = () => {
  const baseUrl = window.location.origin;
  if (baseUrl === ENVIRONMENTS.production.BASE_URL) {
    return "production";
  } else if (baseUrl === ENVIRONMENTS.staging.BASE_URL) {
    return "staging";
  } else if (baseUrl === ENVIRONMENTS.development.BASE_URL) {
    return "development";
  } else {
    // Default to development if not matched
    return "development";
  }
};

const CURRENT_ENV = getEnvironment();

export const URL_CONFIG = {
  ...ENVIRONMENTS[CURRENT_ENV],
};
